import { render, staticRenderFns } from "./Idea_detail_wrap.vue?vue&type=template&id=60f45c8e&scoped=true"
import script from "./Idea_detail_wrap.vue?vue&type=script&lang=js"
export * from "./Idea_detail_wrap.vue?vue&type=script&lang=js"
import style0 from "./Idea_detail_wrap.vue?vue&type=style&index=0&id=60f45c8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f45c8e",
  null
  
)

export default component.exports